import { useEffect, useState } from "react"

/**
 * Tracks the browser's own online/offline signal. It reacts instantly when the network interface
 * drops, while server problems are only discovered by the polled connectivity probe.
 */
export function useBrowserOnline(): boolean {
    const [isOnline, setIsOnline] = useState(() => navigator.onLine)

    useEffect(() => {
        const handleOnline = () => setIsOnline(true)
        const handleOffline = () => setIsOnline(false)

        window.addEventListener("online", handleOnline)
        window.addEventListener("offline", handleOffline)

        return () => {
            window.removeEventListener("online", handleOnline)
            window.removeEventListener("offline", handleOffline)
        }
    }, [])

    return isOnline
}
